import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  switchWrapper: {
    display: "flex",
    alignItems: "center",
  },
  switch: {
    margin: 0,
    whiteSpace: "nowrap", // Default to nowrap for larger screens

    "& .MuiTypography-body1": {
      color: "#000000de",
    },
    "& .MuiSwitch-colorPrimary.Mui-checked": {
      color: "var(--primary-light)",
    },
  },
  // Media query for screens less than or equal to 1660px
  "@media (max-width: 1660px)": {
    switch: {
      whiteSpace: "normal",
    },
  },
  tooltip:{
    marginLeft:'4px'
  }
}));
